import http from './http'

export default {
  getList: params => http.get('/v2/competitors', { params }),
  getFilters: params => http.get('/v2/competitors/filters', { params }),
  exportFile: params => http.get('/v2/competitors/export', { params, responseType: 'blob' })
}



// WEBPACK FOOTER //
// ./src/services/api/competitors.js